import { useEffect, useRef } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import GitHubContributions from '../GitHubContributions/GitHubContributions';
import { ReactComponent as AnimeJsIcon } from "../../Assets/anime-js-logo-v4.svg";
import { ReactComponent as IsometricSVG } from "../../Assets/Isometric_SVG_2.svg";
import SkillCard from '../SkillCard/SkillCard';
import './About.css';

const About = () => {
  const aboutRef = useRef(null);
  
  useEffect(() => {
    const node = aboutRef.current;
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    }, {
      threshold: 0.2,
    });
    
    if (node) {
      observer.observe(node);
    }
    
    return () => {
      if (node) {
        observer.unobserve(node);
      }
    };
  }, []);
  
  const professionalSkills = [
    { name: "C++", icon: "devicon-cplusplus-plain" },
    { name: "C#", icon: "devicon-csharp-plain" },
    { name: "JavaScript", icon: "devicon-javascript-plain" },
    { name: "Node.js", icon: "fa-brands fa-node-js" },
    { name: "React", icon: "devicon-react-original" },
    { name: "HTML5", icon: "devicon-html5-plain" },
    { name: "CSS3", icon: "devicon-css3-plain" },
    { name: "Bootstrap", icon: "devicon-bootstrap-plain" },
    { name: "MongoDB", icon: "devicon-mongodb-plain" },
    { name: "Anime.js", svg_icon: AnimeJsIcon },
    { name: "Express", icon: "devicon-express-original" },
    { name: "PostgreSQL", icon: "devicon-postgresql-plain" },
    { name: "Azure SQL Database", icon: "devicon-azuresqldatabase-plain" },
    { name: "Python", icon: "devicon-python-plain" },
    { name: "Java", icon: "devicon-java-plain" },
  ];
  
  const tools = [
    { name: "Windows10", icon: "devicon-windows8-original" },
    { name: "VS Code", icon: "devicon-vscode-plain" },
    { name: "Git", icon: "devicon-git-plain" },
  ];
  
  return (
    <section className="about-section" id="about">
      <Container>
        <div ref={aboutRef} className="about-container">
          <Row className="about-content">
            <Col md={6} className="about-column text-center">
              <h2 className="section-heading">Who I Am</h2>
              <div className="about-text">
                <p>
                  Hello! I'm Vincent, I am from Toronto, Canada. I am a 
                  passionate software and web developer with a keen 
                  interest in creating dynamic and responsive web 
                  applications, and continuously exploring new 
                  technologies to build innovative applications.
                </p>
                <p>
                  I believe that the best websites are not just visually 
                  appealing but also intuitive and easy to use. My goal 
                  is always to build applications that are efficient, 
                  accessible, and provide exceptional user experiences.
                </p>
              </div>
            </Col>
            
            <Col md={6} className="about-svg-container d-flex justify-content-center align-items-center">
              <div className="isometric-svg-wrapper">
                <IsometricSVG className="isometric-svg" />
              </div>
            </Col>
          </Row>
          
          <Row className="mt-5">
            <Col md={12} className="text-center">
              <h2 className="skillset-heading">My <span className="highlight">Skillset</span></h2>
              <div className="skills-grid">
                {professionalSkills.map((skill, index) => (
                  <SkillCard 
                  key={index} 
                  name={skill.name} 
                  icon={skill.icon} 
                  svg_icon={skill.svg_icon} 
                />
                ))}
              </div>
            </Col>
          </Row>
          
          <Row className="mt-5">
            <Col md={12} className="text-center">
              <h2 className="tools-heading">Tools <span className="highlight">I use</span></h2>
              <div className="tools-grid">
                {tools.map((tool, index) => (
                  <SkillCard 
                    key={index} 
                    name={tool.name} 
                    icon={tool.icon} 
                    svg_icon={tool.svg_icon} 
                  />
                ))}
              </div>
            </Col>
          </Row>
          
          <Row className="mt-5">
            <Col md={12}>
              <GitHubContributions username="VincentDev21" />
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default About;